<template lang="pug">
v-slide-y-transition(mode="out-in")
  v-container(fluid)
    confirm(ref="confirmPopup")

    v-toolbar.mb-3(dark, color="primary")
      v-text-field(
        append-icon="search",
        :elevation="1",
        label="Filtrar",
        single-line,
        hide-details,
        v-model="search"
      )
      v-btn(text, @click="handleAddBatchUsers()") Cargar usuarios
      v-btn(text, to="/commercial_chains") Gestionar grupos
      v-btn(text, to="/users/create") Añadir nuevo usuario

    v-data-table.elevation-1(
      :loading="loading",
      :headers="tableHeaders",
      :footer-props="{ itemsPerPageOptions: rowsPerPage }",
      :custom-filter="usersFilter",
      :search="search",
      :items="users"
    )
      template(v-slot:item.info.commecialName="{ item }") {{ item.info ? item.info.commercialName : '' }}
      template(v-slot:item.info.commercialChain.name="{ item }") {{ item.info && item.info.commercialChain ? item.info.commercialChain.name : '' }}
      template(v-slot:item.agency="{ item }")
        v-icon(v-if="item.roles.indexOf('AGENCY') > -1") check
        v-icon(v-else) close
      template(v-slot:item.active="{ item }")
        v-icon(v-if="item.active") check
        v-icon(v-else) close
      template(v-slot:item.options="{ item }")
        v-btn(
          @click="handleActivate(item)",
          text,
          icon,
          color="success",
          v-if="!item.active"
        )
          v-icon check
        v-btn(
          @click="handleGeneratePassword(item.id)",
          text,
          icon,
          color="warning"
        )
          v-icon https
        v-btn(:to="`/users/${item.id}/edit`", text, icon, color="primary")
          v-icon edit
        v-btn(@click="handleDelete(item)", text, icon, color="red")
          v-icon delete

    v-dialog(width="800px", :value="addBatchUsersDialog", persistent)
      v-card
        v-card-title
          h3.headline Cargar paquete de usuarios
        v-card-text
          .drop-zone(
            @drop="handleBatchUsersFileDrop($event)",
            @dragover="handleDragOver($event)",
            v-if="batchUsers.length < 1"
          ) Arrastra aquí el archivo
          v-data-table.elevation-1(
            :disable-initial-sort="true",
            :headers="batchUsersTableHeaders",
            :items="batchUsers",
            disable-pagination,
            hide-default-footer,
            v-if="batchUsers.length > 0"
          )
            template(slot="items", slot-scope="props")
              td {{ props.item.email }}
              td {{ props.item.password }}
          v-data-table.elevation-1(
            :disable-initial-sort="true",
            disable-pagination,
            :headers="batchUsersErrorsTableHeaders",
            :items="batchErrors",
            hide-default-footer,
            v-if="batchErrors.length > 0"
          )
            template(slot="items", slot-scope="props")
              td {{ props.item.email }}
              td(style="color: red") {{ props.item.error }}
        v-card-actions
          v-btn(color="error", @click="closeAddBatchUsers()") Cancelar
          v-spacer
          v-btn(
            color="success",
            @click="addBatchUsers()",
            :disabled="batchUsers.length < 1 || batchUsersProcessing"
          ) Crear usuarios
</template>

<style>
.has-text-right {
  text-align: right !important;
}
.has-text-center {
  text-align: center !important;
}
.drop-zone {
  width: 100%;
  height: 100px;
  background-color: #ddd;
  border: 4px dashed #aaa;
  border-radius: 15px;
  text-align: center;
  line-height: 100px;
  font-size: 3em;
  text-transform: uppercase;
  font-weight: 300;
  color: #777;
  cursor: pointer;
  margin-bottom: 15px;
}
</style>

<style scoped>
.loader {
  text-align: center;
  padding: 20px 0;
}
</style>

<script>
import XLSX from "xlsx";
import _ from "lodash";
import { accentsTidy } from "@/utils/search";

export default {
  data() {
    return {
      rowsPerPage: [25, 50, 100, { text: "Todo", value: -1 }],
      search: null,
      loading: false,
      users: [],
      batchUsers: [],
      batchErrors: [],
      addBatchUsersDialog: false,
      batchUsersProcessing: false,
      batchUsersErrorsTableHeaders: [
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "email",
        },
        {
          text: "Error",
          align: "left",
          sortable: true,
          value: "error",
        },
      ],
      batchUsersTableHeaders: [
        {
          text: "Email",
          align: "left",
          sortable: false,
          value: "email",
        },
        {
          text: "Contraseña",
          align: "left",
          sortable: false,
          value: "password",
        },
      ],
      tableHeaders: [
        {
          text: "Email",
          align: "left",
          sortable: true,
          value: "email",
        },
        {
          text: "Nombre comercial",
          align: "left",
          sortable: true,
          value: "info.commercialName",
        },
        {
          text: "Grupo",
          align: "left",
          sortable: true,
          value: "info.commercialChain.name",
        },
        {
          text: "Agencia",
          align: "center",
          sortable: false,
          width: "100px",
          value: "agency",
        },
        {
          text: "Activo",
          align: "center",
          width: "100px",
          sortable: true,
          value: "active",
        },
        {
          text: "Opciones",
          align: "right",
          width: "180px",
          sortable: false,
          value: "options",
        },
      ],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      api
        .get("/users")
        .then((res) => {
          this.users = res.data;
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleDelete(item) {
      this.$refs.confirmPopup
        .open("Eliminar", "¿Estás seguro?")
        .then((confirm) => {
          if (confirm) {
            api
              .delete(`/users/${item.id}`)
              .then(() => {
                this.users.splice(this.users.indexOf(item), 1);
              })
              .catch(this.handleError);
          }
        });
    },
    usersFilter(_, search, item) {
      if (search) {
        const rexp = new RegExp(accentsTidy(search), "gi");
        return (
          accentsTidy(String(item.email)).match(rexp) ||
          accentsTidy(item.firstName).match(rexp) ||
          accentsTidy(item.lastName).match(rexp) ||
          (item.info &&
            (accentsTidy(item.info.commercialName).match(rexp) ||
              accentsTidy(item.info.fiscalName).match(rexp) ||
              accentsTidy(item.info.phone).match(rexp) ||
              accentsTidy(item.info.commercialChainName).match(rexp) ||
              (item.info.commercialChain &&
                accentsTidy(item.info.commercialChain.name).match(rexp))))
        );
      }
      return true;
    },
    handleActivate(item) {
      this.$refs.confirmPopup
        .open("Activar", "¿Estás seguro?")
        .then((confirm) => {
          if (confirm) {
            api
              .post(`/users/${item.id}/activate`)
              .then(() => {
                // eslint-disable-next-line no-param-reassign
                item.active = true;
                this.$forceUpdate();
              })
              .catch(this.handleError);
          }
        });
    },
    handleGeneratePassword(id) {
      this.$refs.confirmPopup
        .open("Generar contraseña", "¿Estás seguro?")
        .then((confirm) => {
          if (confirm) {
            api
              .post(`/users/${id}/generatePassword`)
              .then(() => {
                // eslint-disable-next-line no-alert
                alert("Contraseña enviada");
              })
              .catch(this.handleError);
          }
        });
    },
    handleAddBatchUsers() {
      this.addBatchUsersDialog = true;
    },
    closeAddBatchUsers() {
      this.addBatchUsersDialog = false;
    },
    addBatchUsers() {
      this.batchUsersProcessing = true;
      this.batchErrors = [];
      api
        .post("/users/batch", this.batchUsers)
        .then((res) => {
          this.batchUsersProcessing = false;
          this.batchUsers = [];
          this.batchErrors = res.data
            .filter((u) => !u.success)
            .map((a) => Object.assign({}, a.user, { error: a.error }));
          this.fetchData();
        })
        .catch(this.handleError);
    },
    handleBatchUsersFileDrop(e) {
      e.preventDefault();
      const file = e.dataTransfer.files[0];
      const reader = new FileReader();
      reader.onload = (ev) => {
        const workbook = XLSX.read(ev.target.result, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(sheet);

        this.batchUsers = data.map((u) => {
          const user = {};
          _.forEach(u, (value, key) => {
            _.set(user, key, value);
          });
          return user;
        });
      };
      reader.readAsArrayBuffer(file);
    },
    handleDragOver(e) {
      e.preventDefault();
    },
    handleError(err) {
      // eslint-disable-next-line no-console
      console.error(err);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Users/Users.vue